<template>
<div>
<div class="syn-content">
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="50">
      <mu-paper :zDepth="1" rounded >
        <div class="card-toolbar color-black" style="background-color: #ffc107;">
          <span class="card-toolbar-title" style="color: rgba(0, 0, 0, 0.87);">
            CA par département
          </span>
          <span><mu-icon value="cloud_download"/></span>
        </div>
        <div style="width:100%; padding:15px;">
          <mu-row gutter>
              <mu-col width="100" tablet="50" desktop="50">
                <mu-text-field label="Nom" labelFloat v-model="addFile.doc_name" lazy ></mu-text-field>
                <input ref="fileinput" type="file" style="display:none" @change="getFileName()">
                <mu-flat-button @click="openInputFile()" icon="attach_file" color="green"/>
              </mu-col>
          </mu-row>
          <div style="text-align: right; padding:5px; ">
              <mu-raised-button 
                  label="Envoyer" 
                  backgroundColor="#8bc34a"
                  @click="saveFile()"/>
          </div>
        </div>
      </mu-paper>
    </mu-col>
  </mu-row>
</div>
</div>
</template>


<script>
import {col, row} from 'muse-components/grid'
import {list, listItem}  from 'muse-components/list'
// plugin
import dateLocale from '../plugin/dateLocale';

export default {
  name: 'report',
  data () {
    return {
        autoProcess: false,
        saveProgress: false,
        addFile: {
            doc_id:0 , doc_name:'',
            _method:'POST', _path:'document'
        },
    }
  },
  mounted:function (){

  },
  computed: { },
  methods: {
    openInputFile(){
        this.$refs['fileinput'].click()
    },
    getFileName(){
        this.addFile.doc_name = this.$refs['fileinput'].files[0].name //.split(".")[0]
    },
    saveFile(){
        var formFile = new FormData()
        for (var prop in this.addFile) {
            formFile.append(prop, this.addFile[prop])
        }
        formFile.append('doc_file', this.$refs['fileinput'].files[0])
/*        var config = {
            onUploadProgress: function(progressEvent) {
                var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            }
        }*/
        window.axios({
            method: 'POST',
            baseURL: 'http://127.0.0.1:8090/upload',
            data: formFile
        }).then( (response) => {
            console.log(response.data)
            //this.getItemFile()
        })
    }
  },
  components: {
    'mu-list': list,
    'mu-list-item' : listItem,
    'mu-row': row,
    'mu-col': col
  }
}
</script>


// WEBPACK FOOTER //
// Docrecep.vue?51738bd9